// extracted by mini-css-extract-plugin
export default {"label":"Label__label--lc-VFE8B"};